import { createSelectorCreator, defaultMemoize } from 'reselect';
import { get, isEqual } from 'lodash';
import { App } from './types';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const getApplication = createDeepEqualSelector(
  [state => get(state, 'application')],
  application => application as App,
);

export const getMessages = createDeepEqualSelector(
  [getApplication],
  application => application.messages,
);

export const getVersion = createDeepEqualSelector(
  [getApplication],
  application => application.version,
);
